import React from 'react';
import Latex from 'react-latex-next';
import '../../chat.module.css';

import './conversation/conversation.scss'
export default function ParseLatex({
    text
}:{
    text: string
}) {
    // Hardcoded LaTeX equation for testing

    // Regex to match equations between square brackets
    const equations = text.match(/\[([^[\]]+)\]/g) || [];
    return (
        <div className="latex-container">
            {equations.map((equation, index) => (
                <div key={index} className="latex-equation each-formula">
                    <Latex >
                        $${equation.replace(/^\[|\]$/g, '')} $$
                    </Latex>
                </div>
            ))}
        </div>
    );
}
